export default (obj, property) => {
  const map = new Map();

  for (const i in obj) {
    map.set(obj[i][property], obj[i]);
  }

  return map;
};
